<template>
  <div>

    <!-- 面包屑导航 -->
    <el-breadcrumb separator=">">
      <el-breadcrumb-item>Billing Overview</el-breadcrumb-item>
      <el-breadcrumb-item>Subscriptions</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>

    <div class="filter">
      <el-row :gutter="12">


        <el-col :span="12">
          <!-- 1. 选择创建时间 -->
          <span style="width: 100px;border: 0px solid black; display: inline-block;">创建日期:</span>
          <el-select v-model="startDateType" placeholder="请选择" style="width: 100px">
            <el-option label="早于" value="before"></el-option>
            <el-option label="晚于" value="after"></el-option>
            <el-option label="介于" value="between"></el-option>
            <el-option label="不限" value="any"></el-option>
          </el-select>


          <!-- 根据激活时间类型动态展示日期选择器 -->
          <template v-if="startDateType === 'before' || startDateType === 'after'">
            <!-- 单日期选择器 -->
            <el-date-picker v-model="startDate" type="date" placeholder="选择日期" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" style="margin-left: 10px; width: 180px"></el-date-picker>
          </template>

          <template v-if="startDateType === 'between'">
            <!-- 双日期选择器 -->
            <el-date-picker v-model="startDateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              style="margin-left: 10px; width: 300px"></el-date-picker>
          </template>
        </el-col>




        <el-col :span="12">
          <!-- 2. 选择暂停相关 -->
          <span style="width: 100px;border: 0px solid black; display: inline-block;">暂停订阅:</span>

          <!-- 下拉框：创建暂停、开始暂停、结束暂停、暂停中 -->
          <el-select v-model="pauseType" placeholder="暂停类型" style="width: 100px">
            <el-option label="创建暂停" value="creatPause"></el-option>
            <el-option label="开始暂停" value="startPause"></el-option>
            <el-option label="结束暂停" value="resumePause"></el-option>
            <el-option label="暂停中" value="currentlyPaused"></el-option>
          </el-select>

          <el-select v-model="pauseDateType" placeholder="时间关系" style="width: 100px">
            <el-option label="早于" value="before"></el-option>
            <el-option label="晚于" value="after"></el-option>
            <el-option label="介于" value="between"></el-option>
            <el-option label="不限" value="any"></el-option>
          </el-select>


          <!-- 根据激活时间类型动态展示日期选择器 -->
          <template v-if="pauseDateType === 'before' || pauseDateType === 'after'">
            <!-- 单日期选择器 -->
            <el-date-picker v-model="pauseDate" type="date" placeholder="选择日期" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" style="margin-left: 10px; width: 180px"></el-date-picker>
          </template>

          <template v-if="pauseDateType === 'between'">
            <!-- 双日期选择器 -->
            <el-date-picker v-model="pauseDateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              style="margin-left: 10px; width: 300px"></el-date-picker>
          </template>
        </el-col>
      </el-row>


      <el-row :gutter="12">

        <el-col :span="12">
          <!--  选择流失时间 -->
          <span style="width: 100px;border: 0px solid black; display: inline-block;">流失日期:</span>
          <el-select v-model="churnDateType" placeholder="请选择" style="width: 100px">
            <el-option label="早于" value="before"></el-option>
            <el-option label="晚于" value="after"></el-option>
            <el-option label="介于" value="between"></el-option>
            <el-option label="不限" value="any"></el-option>
          </el-select>


          <!-- 根据激活时间类型动态展示日期选择器 -->
          <template v-if="churnDateType === 'before' || churnDateType === 'after'">
            <!-- 单日期选择器 -->
            <el-date-picker v-model="churnDate" type="date" placeholder="选择日期" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" style="margin-left: 10px; width: 180px"></el-date-picker>
          </template>

          <template v-if="churnDateType === 'between'">
            <!-- 双日期选择器 -->
            <el-date-picker v-model="churnDateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              style="margin-left: 10px; width: 300px"></el-date-picker>
          </template>
        </el-col>

        <el-col :span="12">
          <!-- . 选择试用相关 -->
          <span style="width: 100px;border: 0px solid black; display: inline-block;">试用:</span>

          <!-- 下拉框：开始试用、结束试用、试用中、从未试用 startTrial,  endTrial  ,  inTrial ,nevertrial     //  TO DO  Bingooo,  以后这边要考虑增加转化失败, 转化成功 对应的选项   -->
          <el-select v-model="trialType" placeholder="试用类型" style="width: 100px">
            <el-option label="开始试用" value="startTrial"></el-option>
            <el-option label="结束试用" value="endTrial"></el-option>
            <el-option label="试用中" value="inTrial"></el-option>
            <el-option label="从未试用" value="neverTrial"></el-option>
          </el-select>

          <el-select v-model="trialDateType" placeholder="时间关系" style="width: 100px">
            <el-option label="早于" value="before"></el-option>
            <el-option label="晚于" value="after"></el-option>
            <el-option label="介于" value="between"></el-option>
            <el-option label="不限" value="any"></el-option>
          </el-select>


          <!-- 根据激活时间类型动态展示日期选择器 -->
          <template v-if="trialDateType === 'before' || trialDateType === 'after'">
            <!-- 单日期选择器 -->
            <el-date-picker v-model="trialDate" type="date" placeholder="选择日期" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" style="margin-left: 10px; width: 180px"></el-date-picker>
          </template>

          <template v-if="trialDateType === 'between'">
            <!-- 双日期选择器 -->
            <el-date-picker v-model="trialDateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              style="margin-left: 10px; width: 300px"></el-date-picker>
          </template>
        </el-col>
      </el-row>

      <el-row :gutter="12">

        <el-col :span="12">
          <!-- . 当前状态   active canceled  past_due 	trialing  -->
          <div>
            <span style="width: 100px;border: 0px solid black; display: inline-block;">当前状态是:</span>
            <el-radio-group v-model="currentStatus">
              <el-radio-button label="active">订阅中</el-radio-button>
              <el-radio-button label="canceled">已流失</el-radio-button>
              <el-radio-button label="past_due">扣款中</el-radio-button>
              <el-radio-button label="all">任意</el-radio-button>
            </el-radio-group>
          </div>
        </el-col>

        <el-col :span="12">
          <!--  与用户号关联 -->
          <span style="width: 100px;border: 0px solid black; display: inline-block;">关联用户:</span>
          <el-input v-model="users" placeholder="输入用户号(cus_)或者邮箱,可以用逗号分隔多个"
            style="width: 500px;border: 0px solid black; display: inline-block;"></el-input>
        </el-col>


      </el-row>



      <el-row :gutter="12">
        <el-col :span="20"></el-col>
        <el-col :span="4">
          <el-button type="primary" @click="fetchData">Fetch Data</el-button>
        </el-col>

      </el-row>
    </div>

    <!-- 表格 -->
    <el-table :data="tableData" stripe style="width: 100%" height="850"
      :default-sort="{ prop: 'subscriptionID', order: 'descending' }">

      <el-table-column prop="subscriptionID" label="订阅号"   width="290"></el-table-column>
   
      <el-table-column prop="customerEmail" label="订阅Email" width="220"> </el-table-column>
      <el-table-column prop="startDate" label="开始日期"  width="100"   sortable> </el-table-column>
      <el-table-column prop="cancelAtPeriodEnd" label="季末退订" sortable> </el-table-column>
      <el-table-column prop="canceledAt" label="退订日期"   width="100" sortable> </el-table-column>
      <el-table-column prop="endedAt" label="结束日期"  width="100"  sortable> </el-table-column>
      <el-table-column prop="status" label="当前状态" sortable> </el-table-column>

      <el-table-column prop="trialStart" label="试用开始"  width="100"  sortable> </el-table-column>
      <el-table-column prop="trialEnd" label="试用结束"  width="100"  sortable> </el-table-column>

      <el-table-column prop="pauseCreate" label="创建暂停"  width="100"  sortable> </el-table-column>
      <el-table-column prop="pauseStart" label="开始暂停"  width="100"  sortable> </el-table-column>
      <el-table-column prop="pauseEnd" label="结束暂停"  width="100"  sortable> </el-table-column>

      <el-table-column prop="device" label=" 关联设备号"    width="165"> </el-table-column>
      <el-table-column prop="userID" label="关联用户ID" > </el-table-column>

    </el-table>
  </div>
</template>


<script>
import 'core-js/es/array';

export default {
  data() {
    return {
      startDateType: 'any',
      startDate: '',
      startDateRange:   ['',''], // 范围属性

      pauseType: '',
      pauseDateType: 'any',
      pauseDate: '',
      pauseDateRange:   ['',''], // 范围属性

      churnDateType: 'any',
      churnDate: '',
      churnDateRange:   ['',''], // 范围属性

      trialType: '',
      trialDateType: 'any',
      trialDate: '',
      trialDateRange:   ['',''], // 范围属性

      currentStatus: 'all',
      users: '',

      tableData: [],
    };
  },

  created() {
    // 从 URL 中获取参数并赋值
    const query = this.$route.query;
    if (query.startDateType) this.startDateType = query.startDateType;
    if (query.startDate) this.startDate = query.startDate;
    if (query.startDateRange) this.startDateRange = query.startDateRange.split("to");

    if (query.pauseDateType) this.pauseDateType = query.pauseDateType;
    if (query.pauseType) this.pauseType = query.pauseType;
    if (query.pauseDate) this.pauseDate = query.pauseDate;
    if (query.pauseDateRange) this.pauseDateRange = query.pauseDateRange.split("to");

    if (query.churnDateType) this.churnDateType = query.churnDateType;
    if (query.churnDate) this.churnDate = query.churnDate;
    if (query.churnDateRange) this.churnDateRange = query.churnDateRange.split("to");

    if (query.trialType) this.trialType = query.trialType;
    if (query.trialDateType) this.trialDateType = query.trialDateType;
    if (query.trialDate) this.trialDate = query.trialDate;
    if (query.trialDateRange) this.trialDateRange = query.trialDateRange.split("to");

    if (query.currentStatus) this.currentStatus = query.currentStatus;
    if (query.users) this.users = query.users;

//这里加个逻辑,如果上面获取的参数都是没有的, 那么获取数据之前,改成获取最近7天创建的subs 也就是 createdDateType="after",createdDate 是今日往前推7天, 2025-01-01 这种格式 
  // 如果没有获取到任何筛选参数，则设置默认参数为最近7天创建的subs
  if (!query.startDateType && !query.startDate && !query.startDateRange &&
      !query.pauseDateType && !query.pauseType && !query.pauseDate && !query.pauseDateRange &&
      !query.churnDateType && !query.churnDate && !query.churnDateRange &&
      !query.trialType && !query.trialDateType && !query.trialDate && !query.trialDateRange &&
      !query.currentStatus && !query.users) {
    
    // 设置 startDateType 为 "after"
    this.startDateType = "after";

    // 计算今天往前推7天的日期
    const today = new Date();
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 7);

    // 将日期转换为 'YYYY-MM-DD' 格式
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    // 设置startDate 为7天前的日期
    this.startDate = formatDate(sevenDaysAgo);
  }


    // 根据这些参数，发送请求获取数据
    this.fetchData();
  },



  methods: {
    fetchData() {
      this.tableData = [];//先情况表格
  // 准备参数对象
  const params = {
    startDateType: this.startDateType,
    startDate: this.startDate,
    startDateRange: this.startDateRange.length > 0 ? this.startDateRange.join("to") : '',

    pauseType: this.pauseType,
    pauseDateType: this.pauseDateType,
    pauseDate: this.pauseDate,
    pauseDateRange: this.pauseDateRange.length > 0 ? this.pauseDateRange.join("to") : '',

    churnDateType: this.churnDateType,
    churnDate: this.churnDate,
    churnDateRange: this.churnDateRange.length > 0 ? this.churnDateRange.join("to") : '',

    trialType: this.trialType,
    trialDateType: this.trialDateType,
    trialDate: this.trialDate,
    trialDateRange: this.trialDateRange.length > 0 ? this.trialDateRange.join("to") : '',

    currentStatus: this.currentStatus,
    users: this.users
  };

  // 发起请求到后端
  this.$http.get("/da/subs_filter", { params })
    .then(response => {
      // 处理响应数据
      this.tableData = response.data.records;
      this.totalSubs = response.data.total;
          // 请求成功后，清除 URL 中的查询参数
          this.$router.replace({
          path: this.$route.path,  // 保留路径部分
          query: {}                // 清空查询参数
        });
      })


    .catch(error => {
      // 处理错误
      console.error('请求失败:', error);
      // 在此可以处理错误，如显示错误消息
    });
},

  }
}
</script>

<style scoped>
.filter-item {
  margin-bottom: 20px;

  /* 设置边框为1px实线，您可以根据需要调整边框的颜色 */
  border: 1px solid #000;
}

.filter {
  /* 使容器内的所有元素靠左对齐 */
  text-align: left;

  /* 移除内边距 */
  padding: 0;

  /* 移除子元素的外边距，确保没有间距 */
  /* 注意：这里假设filter容器直接包含的子元素是需要设置的目标，如果结构更复杂，可能需要更精确的选择器 */
  >* {
    margin: 0;
  }
}

.el-col {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>